export const OFFICIAL_GROUP_PATH = "/genomicsengland/cloud/services/";

export const getDocType = (locationAnnotation?: string) => {
  if (!locationAnnotation?.startsWith("url:")) return null;
  const url = new URL(locationAnnotation.slice(4));
  return url.pathname.startsWith(OFFICIAL_GROUP_PATH)
    ? "official"
    : "engineering";
};
